import ForwardReplayMinutesControl from './ForwardReplayMinutesControl';

// Pass mode into parent function
const ForwardMinutesControl = ForwardReplayMinutesControl('forward');

ForwardMinutesControl.displayName = 'ForwardMinutesControl';
export default ForwardMinutesControl;
